import React, { Component } from "react";
import SocialLogin from "react-social-login";
import styled from "styled-components";

const Button = styled.div`
  background-color: white;
  border-radius: 5px;
  // border: solid 2px lightgray;
  // padding: 20px;
  margin: 10px 0px;
`;

class SocialButton extends Component {
  state = {};
  render() {
    const { error } = this.props;
    return (
      <>
        <Button onClick={this.props.triggerLogin} {...this.props}>
          {this.props.children}
        </Button>
        {error && <p style={{ textAlign: 'left', color: "red" }}>{error}</p>}
      </>
    );
  }
}

export default SocialLogin(SocialButton);
